import { log } from '../utils/logger';
import consumer from './consumer';

consumer.subscriptions.create('Notifications::UserChannel', {
  connected() {
    log('connected to Notifications::UserChannel');
  },

  disconnected() {
    log('disconnected from Notifications::UserChannel');
  },

  received(data) {
    log('message received from Notifications::UserChannel', data);

    const notificationsContainer = document.getElementById(
      'notification-container'
    );

    if (!notificationsContainer) {
      log('notification-container not found');
      return;
    }

    notificationsContainer.innerHTML = data.html;
  },
});
